import { Core } from "@/core/Core";

export default {
  
  async getPromotionModals(context, query) {
    try {
      return await Core.request('GET', '/api/promotion_modals', query);
    } catch (e) {
      return null;
    }
  },
  
  async savePromotionModal(context, {id, data}) {
    try {
      return await Core.request('PUT', `/api/promotion_modals/${id}`, data);
    } catch (e) {
      return null;
    }
  },
  
  async createPromotionModal(context, {data}) {
    try {
      return await Core.request('POST', '/api/promotion_modals', data);
    } catch (e) {
      return null;
    }
  },
  
  async deletePromotionModal(context, {id}) {
    try {
      return await Core.request('DELETE', `/api/promotion_modals/${id}`);
    } catch (e) {
      return null;
    }
  },
}
